import { useMemo } from "react";
import {
  Checklist,
  HealthAndSafety,
  Settings,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/common/PageHeader";
import { PageHub } from "@/components/common/PageHub";

export function InsuranceSettings() {
  const navigate = useNavigate();

  const cards = useMemo(
    () => [
      {
        title: "Gerenciar operadoras",
        icon: <Settings fontSize="large" sx={{ color: "primary800.main" }} />,
        description:
          "Configure e gerencie as operadoras e planos de saúde aceitos pela sua clínica",
        onClick: () => navigate("/manageplans"),
      },
      {
        title: "Emissão de guias",
        icon: <Checklist fontSize="large" sx={{ color: "primary800.main" }} />,
        description: "Emissão e gerenciamento de guias TISS",
        onClick: () => navigate("/insuranceguide"),
      },
    ],
    [navigate],
  );

  return (
    <PageHub
      header={
        <PageHeader
          title="Gestão de planos de saúde"
          centered
          icon={HealthAndSafety}
        />
      }
      sections={[
        {
          cards,
        },
      ]}
    />
  );
}
